"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActivitiesInModule = void 0;
var getActivitiesInModule = function (moduleId, data) {
    var module = data.modules.find(function (mod) { return mod.id === moduleId; });
    if (!module)
        throw new Error("Module not found");
    return module.objectiveIds
        .map(function (objectiveId) {
        var objective = data.objectives.find(function (objective) { return objective.id === objectiveId; });
        if (!objective)
            throw new Error("Objective not found: " + objectiveId);
        return objective.activityIds;
    })
        .reduce(function (flattened, activityIds) { return __spreadArray(__spreadArray([], flattened, true), activityIds, true); }, [])
        .map(function (activityId) {
        var activity = data.activities.find(function (activity) { return activity.id === activityId; });
        if (!activity)
            throw new Error("Activity not found: " + activityId);
        return activity;
    });
};
exports.getActivitiesInModule = getActivitiesInModule;
